var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { BorderWidth, Colors, Breakpoints, TextStyle, Text, Spacing, Inset, InsetSize, } from '@doordash/design-language';
import { GridContainer, GridContainerSpacing } from '@doordash/component-grid';
import Button, { ButtonIconType } from '@doordash/component-button';
export var TileContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  border: ", "px solid ", ";\n  min-height: 420px;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  border: ", "px solid ", ";\n  min-height: 420px;\n  height: 100%;\n"])), BorderWidth.Regular, Colors.BorderPrimary);
export var CalendarGrid = styled(GridContainer).attrs(function () { return ({
    columnGutter: GridContainerSpacing.None,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0px;\n  grid-template-columns: ", ";\n\n  @media screen and (max-width: ", "px) {\n    grid-template-columns: ", ";\n    overflow-x: scroll;\n  }\n"], ["\n  padding: 0px;\n  grid-template-columns: ",
    ";\n\n  @media screen and (max-width: ", "px) {\n    grid-template-columns: ",
    ";\n    overflow-x: scroll;\n  }\n"])), function (props) {
    return props.showWeekendsView
        ? 'repeat(7, minmax(170px, 1fr))'
        : 'repeat(5, minmax(170px, 1fr))';
}, Breakpoints.Desktop - 1, function (props) {
    return props.showWeekendsView
        ? 'repeat(14, minmax(150px, 1fr))'
        : 'repeat(10, minmax(150px, 1fr))';
});
export var DayTitleText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Title1,
}); })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  line-height: ", "px;\n  ", "\n"], ["\n  line-height: ", "px;\n  ",
    "\n"])), Spacing.XxLarge, function (props) {
    if (props.shouldMarkDate) {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        width: 48px;\n        height: 48px;\n        border-radius: 50%;\n        color: ", ";\n        text-align: center;\n        background: ", ";\n      "], ["\n        width: 48px;\n        height: 48px;\n        border-radius: 50%;\n        color: ", ";\n        text-align: center;\n        background: ", ";\n      "])), Colors.SystemWhite, Colors.SystemBlack);
    }
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
});
export var NewOrderButton = styled(Button).attrs(function () { return ({
    isRaised: true,
    size: Button.Sizes.Small,
    type: Button.Types.Plain,
    leadingIcon: ButtonIconType.Add,
}); })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), Colors.SystemGrey100);
export var NewOrderButtonWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  visibility: ", ";\n"], ["\n  visibility: ",
    ";\n"])), function (props) {
    return props.visibility ? 'visible' : 'hidden';
});
export var GoEntriesContainer = styled(Inset).attrs(function () { return ({
    size: InsetSize.XSmall,
}); })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
